import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CNLabo } from '../models/cnlabo';
import { CNPatient } from '../models/cnpatient';
import { SNItemFactory } from '../models/snitemfactory';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';

export enum LaboServiceFilter {
  all = 'all'
}

export class LaboServiceSubject {
  private becareService: BecareService;
  private myPatient: CNPatient;
  private myName: string;
  private myFilter: LaboServiceFilter;
  private paged: boolean | number;
  private buffer: CNLabo[];
  public labos: BehaviorSubject<CNLabo[]>;
  public myStart: number;
  public myLimit: number;
  public length: number;

  private laboUrl = '';

  constructor(becare: BecareService, patient: CNPatient, name: string, filter: LaboServiceFilter, paged: boolean | number) {
    this.becareService = becare;
    this.myName = name;
    this.myFilter = filter;
    this.paged = paged;
    if (paged) {
      this.myStart = 0;
      this.myLimit = 10;
      this.length = 0;
    }
    this.labos = new BehaviorSubject<CNLabo[]>([]);
    // Set patient, build rest url and query first buffer
    this.patient = patient;
  }

  private load() {
    if (!this.laboUrl) {
      return;
    }
    this.becareService.call(this.laboUrl).subscribe(result => {
      if (result.success === true && result.labos !== undefined) {
        const factory = new SNItemFactory();
        this.buffer = factory.itemsFromJson(result.labos);
        this.length = result.total;
        this.labos.next(this.buffer);
      }
    });
  }

  private buildUrl() {
    if (this.paged) {
      this.laboUrl = '/fr/patient/' + this.myPatient.id + '/labos?start=' + this.myStart + '&limit=' + this.myLimit;
    } else {
      // switch (this.myFilter) {
      //   case LaboServiceSubject.active:
      //     this.problemUrl = '/fr/patient/' + this.myPatient.id + '/problems/active';
      //     break;
      //   case LaboServiceSubject.notactive:
      //     this.problemUrl = '/fr/patient/' + this.myPatient.id + '/problems/notactive';
      //     break;
      //   default:
      //     this.problemUrl = '';
      // }
    }
  }

  clear(): void {
    this.buffer = [];
    this.length = 0;
    this.labos.next([]);
  }

  set patient(patient: CNPatient) {
    this.myPatient = patient;
    if (!this.myPatient) {
      return;
    }
    this.buildUrl();
    this.load();
  }

  set start(start: number) {
    this.myStart = start;
    this.buildUrl();
    this.load();
  }

  set limit(limit: number) {
    this.myLimit = limit;
    this.buildUrl();
    this.load();
  }
}

@Injectable({
  providedIn: 'root'
})
export class LaboService {

  private static instance: LaboService = null;
  private currentpatient: CNPatient;
  @Output() clear = new EventEmitter<boolean>();

  private subjects: Map<string, LaboServiceSubject> = new Map();

  constructor(private becare: BecareService, private patient: PatientService) {
    LaboService.instance = this;
    this.patient.patientSelectedEvent.subscribe(patientselected => {
      this.currentpatient = patientselected;
      this.subjects.forEach((subject: LaboServiceSubject, name: string) => {
        subject.patient = this.currentpatient;
      });
      this.clear.emit(true);
    });
    // Initiate with current selected patient
    this.currentpatient = this.patient.patient;
  }

  public static getInstance(): LaboService {
    return LaboService.instance;
  }

  public getSubject(name: string, filter?: LaboServiceFilter, paged?: boolean | number): LaboServiceSubject {
    if (this.subjects.has(name)) {
      return this.subjects.get(name);
    }
    if (!filter && !paged) {
      return undefined;
    }
    // Build new service subject
    const newSubject = new LaboServiceSubject(this.becare, this.currentpatient, name, filter, paged);
    this.subjects.set(name, newSubject);
    return newSubject;
  }
}
